/**
 * Created with IntelliJ IDEA.
 * User: itaik
 * Date: 4/17/13
 * Time: 10:39 AM
 * To change this template use File | Settings | File Templates.
 */

/*
 A FilteredAppRouter which extends BaseFilteredAppRouter to implement filters
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Logger = require("logger");
    var Backbone = require("backbone");
    var Marionette = require("marionette");
    var BaseFilteredAppRouter = require("routers/BaseFilteredAppRouter");
    var RouteNameBuilder = require("routers/routeNameBuilder");
    var registrar = require("modules/registerModule");
    var logger = Logger.getLogger("LEFramework");

    var FilteredAppRouter = BaseFilteredAppRouter.extend({
        before:{
            // Using instance methods
            "users(:/id)":"checkAuthentication",

            // Using inline filter definition
            "*any":function (fragment, args) {
                logger.info('Attempting to load ' + fragment + ' with arguments: ' + args);

                // TODO: Implement a check for authentication token and keep alive for all navigations
                return true;
            }
        },
        after:{
            // Using inline filter definition
            "*any":function (fragment, args) {
                logger.info('Loaded ' + fragment + (args ? ' with arguments: ' + args : ''));

                return true;
            }
        },
        checkAuthentication:function (fragment, args) {
            logger.info('Check Auth had been called with ' + fragment + (args ? ' and with arguments: ' + args : ''));
        }
    });

    return FilteredAppRouter;

});
